import React, { FC } from 'react'
import { styled, utilities } from '@creditas/stylitas'
import { Navigation } from '@creditas/icons'
import { useQueryParam, StringParam } from 'use-query-params'

const Container = styled.button`
  ${utilities.reset.button()}
  background-color: red;
  background: #fff;
  border-radius: 16px;
  border: 1px solid #eee;
  cursor: pointer;
  display: flex;
  height: 32px;
  margin-right: 12px;
  min-width: 32px;
  outline: none;
  position: relative;

  :hover {
    border-color: #4499ee;

    svg {
      fill: #4499ee;
    }

    p {
      max-width: 7rem;
      transition-delay: 0.1s;
    }
  }
`

const HelperText = styled.p`
  margin-top: 5px;
  max-width: 0;
  overflow: hidden;
  transition-delay: 0.5s;
  transition: max-width 0.5s;
  white-space: nowrap;
`

const IconArea = styled.div`
  width: 30px;
`

const IconPositioner = styled.div`
  position: absolute;
  right: -9px;
  top: -9px;
`

const Sort: FC = () => {
  const [orientation, setOrientation] = useQueryParam(
    'orientation',
    StringParam,
  )
  const safeOrientation = orientation || 'asc'
  const isAsc = safeOrientation === 'asc'

  return (
    <Container onClick={() => setOrientation(isAsc ? 'desc' : 'asc')}>
      <HelperText>
        &nbsp;&nbsp;&nbsp;
        {isAsc ? 'Asc' : 'Desc'}
      </HelperText>
      <IconArea>
        <IconPositioner>
          {isAsc ? (
            <Navigation.ChevronDown fontSize="large" />
          ) : (
            <Navigation.ChevronUp fontSize="large" />
          )}
        </IconPositioner>
      </IconArea>
    </Container>
  )
}

export { Sort }
